import {
    compareConstructionNumberAdd,
    compareConstructionNumberRemove,
} from '@source/store/compare';

import { getConstructionNumberIds } from './construction-numbers-id';

export const fillCompare = () => {
    getConstructionNumberIds().forEach((id) => {
        compareConstructionNumberAdd(id);
    });
};

export const clearCompare = () => {
    getConstructionNumberIds().forEach((id) => {
        compareConstructionNumberRemove(id);
    });
};
